var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":"https://cdn-icons-png.flaticon.com/512/564/564619.png","alt":"No autorizado"}}),_c('h1',[_vm._v("401")]),_c('h2',[_vm._v("¡No tiene permiso para ver esta página!.")]),_c('p',[_vm._v("Póngase en contacto con el administrador del sistema.")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Volver al inicio")])])
}]

export { render, staticRenderFns }